document.documentElement.classList.add('atene-js');

document.addEventListener('DOMContentLoaded', () => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('.atene-reveal');

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => observer.observe(item));
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.atene-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.querySelectorAll('.atene-quick-add').forEach((form) => {
    if (!(form instanceof HTMLFormElement)) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Add to basket failed');
        const cart = await fetch(`${shopRoot}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-atene-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        button.textContent = 'Added to basket';
        window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1300);
      } catch (_error) {
        form.submit();
      }
    });
  });
});
